export class Eligibility {
  constructor({
    showReports,
    orderCount,
    showStartTrial,
    showTrialEnded,
    showUnlock,
  }) {
    this.showReports = showReports;
    this.orderCount = orderCount;
    this.showStartTrial = showStartTrial;
    this.showTrialEnded = showTrialEnded;
    this.showUnlock = showUnlock;
  }

  static fromJson(json) {
    return new Eligibility({
      showReports: json.show_reports,
      orderCount: json.order_count,
      showStartTrial: json.show_starttrial,
      showTrialEnded: json.show_trialended,
      showUnlock: json.show_unlock,
    });
  }

  toString() {
    return `Eligibility(showReports: ${this.showReports}, orderCount: ${this.orderCount}, showStartTrial: ${this.showStartTrial}, showTrialEnded: ${this.showTrialEnded}, showUnlock: ${this.showUnlock})`;
  }
}
